import { type Instance, action, register, types } from "@gadgetinc/mobx-quick-tree";
import { GadgetDomainModelClass, contentHash } from "../utils";
import type { ProblemsList } from "../problems/ProblemsList";
import { createProblemFinder } from "../problems/createProblemFinder";
import { WorkspacePageType } from "../WorkspacePageType";

export const SentryDatasourceProblems = createProblemFinder<Instance<typeof SentryDatasource>>(
  {
    name: {
      validSentryDsn: {
        message: "is not a valid Sentry DSN",
        inContextMessage: "is not a valid Sentry DSN",
      },
    },
  },
  {
    name: "Sentry Connection",
    tabType: WorkspacePageType.SentryConnectionIndex,
  }
);

@register
export class SentryDatasource extends GadgetDomainModelClass("SentryDatasource", {
  name: types.string,
}) {
  get contentHash() {
    return contentHash([this.name]);
  }

  get problems(): ProblemsList {
    return SentryDatasourceProblems(this);
  }

  @action
  setName(name: string) {
    this.name = name;
  }
}
